// PATH: src/api/monitoring/useMonitoringV2Api.ts
import { useApiClient } from '../apiClients';
import { buildMonitoringV2Api, type MonitoringV2Api } from './v2';

/**
 * Client v2 branché sur le client HTTP de l'application (cookies de session).
 *
 * Identité : l'objet renvoyé change à chaque rendu (comme `useApiClient`,
 * volontairement non modifié — mémoire projet). Ne jamais le mettre dans un
 * tableau de dépendances : passer par une ref (`useMonitoringApiRef`).
 */
export const useMonitoringV2Api = (): MonitoringV2Api => {
    const client = useApiClient('tilmicode');
    return buildMonitoringV2Api(client);
};
